import * as React from "react";
const SvgSortDesc = (props) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 14 10", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { id: "Union", fillRule: "evenodd", clipRule: "evenodd", d: "M0 0H14V2H0V0ZM0 4H10V6H0V4ZM6 8H0V10H6V8Z", fill: "#051350" }));
export default SvgSortDesc;
